/**! 
 * @uiw/formatter v1.3.2 
 * Get a formatted date. 
 * 
 * Copyright (c) 2022 Kenny Wang <wowohoo@qq.com> 
 * https://github.com/uiwjs/date-formatter.git 
 * Licensed under the MIT license 
 */

var dateRegex = /(?=(YYYY|YY|MM|DD|HH|mm|ss|ms))\1([:/]*)/g;
var timespan = {
    YYYY: ['getFullYear', 4],
    YY: ['getFullYear', 2],
    MM: ['getMonth', 2, 1],
    DD: ['getDate', 2],
    HH: ['getHours', 2],
    mm: ['getMinutes', 2],
    ss: ['getSeconds', 2],
    ms: ['getMilliseconds', 3],
};
function formatter(str, date, utc) {
    if (typeof str !== 'string') {
        date = str;
        str = 'YYYY-MM-DD';
    }
    return str.replace(dateRegex, function (match, key, rest) {
        var args = timespan[key];
        var chars = args[1];
        var name = args[0];
        if (utc === true) {
            name = "getUTC".concat(name.slice(3));
        }
        if (!date) {
            date = new Date();
        }
        var val = "00".concat(String(date[name]() + (args[2] || 0)));
        return val.slice(-chars) + (rest || '');
    });
}
formatter.utc = function (str, date) {
    return formatter(str, date, true);
};

export { formatter as default };
//# sourceMappingURL=index.js.map
